import React, { useEffect, useRef, useState } from "react";
import GlobalHeader from "../../../components/header";
import Footer from "../../../components/footer";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  styled,
  tableCellClasses,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import useApi from "../../../hooks/useApi";
import useSnack from "../../../hooks/useSnack";
import { useParams } from "react-router-dom";
import SnackAlert from "../../../components/SnackAlert";
import GalleryProfile from "../../../components/GalleryProfile";
import TitleIcon from "../../../components/TitleIcon";
import EditIcon from "@mui/icons-material/Edit";
import { LoadingButton } from "@mui/lab";
import EuroIcon from "@mui/icons-material/Euro";
import AddIcon from "@mui/icons-material/Add";
import AbcIcon from "@mui/icons-material/Abc";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import PercentIcon from "@mui/icons-material/Percent";
import NumbersIcon from "@mui/icons-material/Numbers";
import { Add } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  validateDates,
  editFormIsNotEmpty,
  validateMinMaxIsValid,
} from "../../../utils/validations";

function dateToInput(fechaOriginal) {
  if (!!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
    const dateObject = new Date(fechaOriginal);
    const año = dateObject.getUTCFullYear();
    const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
    const día = dateObject.getUTCDate().toString().padStart(2, "0");

    return `${año}-${mes}-${día}`;
  } else return fechaOriginal;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0B2A41",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "normal",
  },
}));

function EditProject() {
  const [mainData, setMainData] = useState({ gallery_edit: [] });
  const [galleryPreview, setGalleryPreview] = useState();
  const [stadisticsData, setStadisticsData] = useState(false);
  const [previewPicture, setPreviewPicture] = useState(false);

  // new bill
  const [modalNewBill, setModalNewBill] = useState(false);
  const [dataNewBill, setDataNewBill] = useState({
    name: "",
    value: "",
  });

  // delete bill
  const [openModalDeleteBill, setOpenModalDeleteBill] = useState(false);
  const [billToDeleteId, setBillToDeleteId] = useState(undefined);
  const [loadingDeleteBill, setLoadingDeleteBill] = useState(false);

  // edit bill
  const [openModalEditBill, setOpenModalEditBill] = useState(false);
  const [billToEdit, setBillToEdit] = useState(undefined);
  const [loadingEditBill, setLoadingEditBill] = useState(false);

  // new income
  const [modalNewIncome, setModalNewIncome] = useState(false);

  // delete income
  const [openModalDeleteIncome, setOpenModalDeleteIncome] = useState(false);
  const [incomeToDeleteId, setIncomeToDeleteId] = useState(undefined);
  const [loadingDeleteIncome, setLoadingDeleteIncome] = useState(false);

  // edit income
  const [openModalEditIncome, setOpenModalEditIncome] = useState(false);
  const [incomeToEdit, setIncomeToEdit] = useState(undefined);
  const [loadingEditIncome, setLoadingEditIncome] = useState(false);

  const [isLoading, setIsLoading] = useState();
  const [isLoadingModals, setIsLoadingModals] = useState(false);
  const fileInputPhoto = useRef(null);
  const fileGallery = useRef(null);

  // UTILS
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [backdropLoading, setBackdropLoading] = useState(false);
  const params = useParams();

  const UpdateDetailsProject = () => {
    let tempData = {
      information: mainData.information,
      min_offered_capital: mainData.min_offered_capital,
      max_offered_capital: mainData.max_offered_capital,
      min_stake: mainData.min_stake,
      max_stake: mainData.max_stake,
      min_return_investment: mainData.min_return_investment,
      max_return_investment: mainData.max_return_investment,
      deadpoint: "TEST",
      min_marketing: mainData.min_marketing,
      max_marketing: mainData.max_marketing,
      min_construction: mainData.min_construction,
      max_construction: mainData.max_construction,
      warranty_inmobiliaria: "IDK",
      warranty_economica: "IDK",
    };
    loadApi(`detail_project/update_detail_project/${params.id}`, true, "put", {
      ...tempData,
    })
      .then(() => {
        showSnack("Proyecto actualizado con éxito", "success");
      })
      .catch((e) => {
        showSnack(e.message);
      });
  };

  const UpdateProject = () => {
    setIsLoading(true);
    let tempData = {
      photo_profile: mainData.photo_profile,
      photo_profile_edit: mainData.photo_profile_edit || "",
      name: mainData.name,
      name_business: mainData.name_business,
      information: mainData.information,
      objective: mainData.objective,
      loans: mainData.loans,
      esti_profitability: mainData.esti_profitability,
      min_investment: mainData.min_investment,
      initial_date: mainData.initial_date.split("T")[0],
      final_date: mainData.final_date.split("T")[0],
      gallery: mainData.gallery,
      gallery_edit: mainData.gallery_edit || "",
      min_offered_capital: mainData.DetailProject.min_offered_capital,
      max_offered_capital: mainData.DetailProject.max_offered_capital,
      min_return_investment: mainData.DetailProject.min_return_investment,
      max_return_investment: mainData.DetailProject.max_return_investment,
      min_stake: mainData.DetailProject.min_stake,
      max_stake: mainData.DetailProject.max_stake,
      min_marketing: mainData.DetailProject.min_marketing,
      max_marketing: mainData.DetailProject.max_marketing,
      min_construction: mainData.DetailProject.min_construction,
      max_construction: mainData.DetailProject.max_construction,
      warranty_inmobiliaria: mainData.DetailProject.warranty_inmobiliaria,
      warranty_economica: mainData.DetailProject.warranty_economica,
      invested: mainData.invested,
      expenses_marketing: mainData.ExpensesProjects[0].expenses_marketing,
      expenses_construction: mainData.ExpensesProjects[0].expenses_construction,
      expenses_vehicles: mainData.ExpensesProjects[0].expenses_vehicles,
      expenses_wages: mainData.ExpensesProjects[0].expenses_wages,
    };

    let response = editFormIsNotEmpty(tempData);
    if (!response) {
      showSnack("Debes completar todos los campos");
      setIsLoading(false);
      return;
    }

    const datesAreValid = validateDates(
      tempData.initial_date,
      tempData.final_date,
      showSnack,
      true
    );
    if (!datesAreValid) {
      setIsLoading(false);
      return;
    }

    let minMaxIsValid = validateMinMaxIsValid(
      tempData.min_offered_capital,
      "Capital mínimo ofrecido",
      tempData.max_offered_capital,
      "Capital máximo ofrecido",
      showSnack
    );
    if (!minMaxIsValid) {
      setIsLoading(false);
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      tempData.min_return_investment,
      "Mínimo retorno de inversión",
      tempData.max_return_investment,
      "Máximo retorno de inversión",
      showSnack
    );
    if (!minMaxIsValid) {
      setIsLoading(false);
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      tempData.min_stake,
      "Participaciones mínimas a dar",
      tempData.max_stake,
      "Participaciones máximas a dar",
      showSnack
    );
    if (!minMaxIsValid) {
      setIsLoading(false);
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      tempData.min_marketing,
      "Minimo invertido marketing",
      tempData.max_marketing,
      "Máximo invertido marketing",
      showSnack
    );
    if (!minMaxIsValid) {
      setIsLoading(false);
      return;
    }

    minMaxIsValid = validateMinMaxIsValid(
      tempData.min_construction,
      "Minimo invertido construcción",
      tempData.max_construction,
      "Máximo invertido construcción",
      showSnack
    );
    if (!minMaxIsValid) {
      setIsLoading(false);
      return;
    }

    loadApi(`project/${params.id}`, true, "put", tempData, true)
      .then((response) => {
        showSnack(response.data.message, "success");
      })
      .catch((e) => showSnack(e.message))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handlerUpdate = () => {
    UpdateProject();
  };

  const GetDetailsProject = async () => {
    setBackdropLoading(true);

    loadApi(`project/${params.id}`, true, "get")
      .then((response) => {
        setStadisticsData({
          bills: response.data.project.BillsProjects,
          expected_income: response.data.project.ExpectedIncomes,
        });
        setGalleryPreview(response.data.project.gallery);
        const tempData = response.data.project;
        tempData.diffDays = response.data.diffDays;
        setMainData(tempData);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setBackdropLoading(false));
  };
  const handlerChangePreviewImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMainData({ ...mainData, photo_profile_edit: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewPicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const formatNumberWithDots = (number) => {
    if (number === undefined) {
      return "";
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");

    return rawValue;
  };

  const handlerAddGalleryImage = (e) => {
    const file = e.target.files[0];
    if (galleryPreview.length === 10) {
      showSnack("No se pueden agregar más de 10 imágenes");
      return;
    }
    const isDuplicate = galleryPreview.filter((x) => x.name === file.name);

    if (isDuplicate.length !== 0) {
      fileGallery.current.value = "";
      showSnack("Error, el archivo ya existe");
      return;
    }

    const reader = new FileReader();
    setMainData({
      ...mainData,
      gallery_edit: [...(mainData.gallery_edit || []), file],
    });
    reader.onloadend = () => {
      setGalleryPreview([
        ...galleryPreview,
        { url: reader.result, name: file.name },
      ]);
    };
    reader.readAsDataURL(file);
  };

  const calcDates = (date1, date2) => {
    const initialDate = new Date(date1);
    const finalDate = new Date(date2);

    const tiempo1 = initialDate.getTime();
    const tiempo2 = finalDate.getTime();

    const diferenciaMilisegundos = tiempo2 - tiempo1;

    const milisegundosPorDia = 24 * 60 * 60 * 1000;
    const diferenciaDias = diferenciaMilisegundos / milisegundosPorDia;
    return diferenciaDias;
  };

  function dateToInput(fechaOriginal) {
    if (!!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(fechaOriginal)) {
      const dateObject = new Date(fechaOriginal);
      const año = dateObject.getUTCFullYear();
      const mes = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
      const día = dateObject.getUTCDate().toString().padStart(2, "0");

      return `${año}-${mes}-${día}`;
    } else return fechaOriginal;
  }

  const handleNewBill = (type = "bill") => {
    if (dataNewBill.name === "" || dataNewBill.value === "") {
      showSnack("Debe llenar todos los campos");
      return;
    }

    if (dataNewBill.value.startsWith("0")) {
      showSnack("El valor no puede ser cero");
      return;
    }

    if (dataNewBill.value.startsWith("-")) {
      showSnack("El valor no puede ser negativo");
      return;
    }

    setIsLoadingModals(true);
    const myDate = new Date();
    let year = myDate.getFullYear();
    let month = (myDate.getMonth() + 1).toString().padStart(2, "0");
    let day = myDate.getDate().toString().padStart(2, "0");
    let resultDate = `${year}-${month}-${day}`;
    if (type === "bill") {
      loadApi("bills/" + params.id, true, "post", { ...dataNewBill })
        .then((response) => {
          let tempData = stadisticsData;
          if (type === "bill") {
            tempData = {
              ...tempData,
              bills: [...tempData.bills, response.data.newBill],
            };
          } else {
            tempData = {
              ...tempData,
              expected_income: [
                ...tempData.expected_income,
                response.data.newExpectedIncome,
              ],
            };
          }
          setDataNewBill({ name: "", value: "" });
          setStadisticsData(tempData);
          showSnack(
            type === "bill"
              ? response.data.message
              : "Ingreso previsto añadido",
            "success"
          );
          setModalNewBill(false);
          setModalNewIncome(false);
        })
        .catch((e) => {
          showSnack(e.message);
        })
        .finally(() => {
          setIsLoadingModals(false);
        });
    } else {
      loadApi("expected/" + params.id, true, "post", {
        ...dataNewBill,
      })
        .then((response) => {
          let tempData = stadisticsData;
          if (type === "bill") {
            tempData = {
              ...tempData,
              bills: [
                ...tempData.bills,
                {
                  name: dataNewBill.name,
                  value: dataNewBill.value,
                  createdAt: resultDate,
                },
              ],
            };
          } else {
            tempData = {
              ...tempData,
              expected_income: [
                ...tempData.expected_income,
                response.data.newExpectedIncome,
              ],
            };
          }

          setDataNewBill({ name: "", value: "" });
          setStadisticsData(tempData);
          showSnack(
            type === "bill" ? "Gasto Añdido" : "Ingreso previsto añadido",
            "success"
          );
          setModalNewBill(false);
          setModalNewIncome(false);
        })
        .catch((e) => {
          showSnack(e.message);
        })
        .finally(() => {
          setIsLoadingModals(false);
        });
    }
  };

  useEffect(() => {
    GetDetailsProject();
  }, []);

  return (
    <>
      <GlobalHeader />
      <Stack
        sx={{
          minHeight: "calc(100vh - 120px)",
          width: { xs: "95vw", sm: "85vw", md: "80vw", lg: "72vw" },
          marginInline: "auto",
          pt: 5,
          pb: 4,
          backgroundColor: { xs: "none", md: "white" },
        }}
      >
        {mainData?.name && stadisticsData ? (
          <Stack component="section" px={2}>
            <TitleIcon
              icon={<EditIcon fontSize="large" />}
              title="Editar Proyecto"
            />
            <Stack
              component="header"
              flexDirection={{ xs: "column", md: "row" }}
              gap={5}
              mb={4}
            >
              <Stack
                justifyContent="center"
                alignItems="center"
                component="article"
                sx={{
                  boxShadow: previewPicture
                    ? "-6px 5px 8px -1px rgba(0,0,0,0.31)"
                    : "none",
                  cursor: "pointer",
                  width: { xs: "100%", md: "40%" },
                  height: { xs: 250, md: 270 },
                  border: "1px solid gray",
                  borderRadius: 2,
                }}
                onClick={() => fileInputPhoto.current.click()}
              >
                {!!mainData.photo_profile[0].url ? (
                  <img
                    width="100%"
                    height="100%"
                    style={{ objectFit: "cover", borderRadius: 8 }}
                    src={previewPicture || mainData.photo_profile[0].url}
                  />
                ) : (
                  <AddAPhotoIcon sx={{ color: "#87878757" }} fontSize="large" />
                )}
                <input
                  style={{ display: "none" }}
                  type="file"
                  accept=".jpg, .png, .jpeg, .webp"
                  ref={fileInputPhoto}
                  onChange={handlerChangePreviewImage}
                />
              </Stack>
              <Stack
                gap={2}
                sx={{
                  width: { xs: "100%", md: "60%" },
                }}
              >
                <Stack>
                  <Typography component="h3" variant="h6" mb={2}>
                    Datos Proyecto
                  </Typography>
                  <TextField
                    label="Nombre del Proyecto"
                    value={mainData.name}
                    onChange={({ target }) => {
                      if (target.value.length > 40) {
                        showSnack(
                          "El nombre del proyecto solo puede tener un máximo de 40 caracteres"
                        );
                        return;
                      }
                      setMainData({ ...mainData, name: target.value });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Nombre de la Empresa"
                    value={mainData.name_business}
                    onChange={({ target }) => {
                      if (target.value.length > 40) {
                        showSnack(
                          "El nombre de la empresa solo puede tener un máximo de 40 caracteres"
                        );
                        return;
                      }
                      setMainData({
                        ...mainData,
                        name_business: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    label="Información del proyecto"
                    required
                    sx={{ height: "80px" }}
                    multiline
                    rows={2}
                    value={mainData.information}
                    onChange={({ target }) => {
                      if (target.value.length > 730) {
                        showSnack(
                          "La información solo puede tener un máximo de 730 caracteres"
                        );
                        return;
                      }
                      setMainData({
                        ...mainData,
                        information: target.value,
                      });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AbcIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
            <Stack mb={2}>
              <Typography component="h3" variant="h6" mb={2}>
                General
              </Typography>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                gap={3}
                mb={2}
              >
                <TextField
                  label="Objetivo"
                  type="text"
                  value={formatNumberWithDots(mainData.objective)}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);

                      setMainData({ ...mainData, objective: result });
                    }
                  }}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Préstamos"
                  type="text"
                  fullWidth
                  value={formatNumberWithDots(mainData.loans)}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      setMainData({ ...mainData, loans: result });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                mb={2}
                gap={3}
              >
                <TextField
                  type="text"
                  label="Rentabilidad estimada"
                  value={formatNumberWithDots(
                    mainData.esti_profitability.replace("%", "")
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      setMainData({
                        ...mainData,
                        esti_profitability: result + "%",
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
                <TextField
                  label="Inversión Mínima"
                  type="text"
                  value={formatNumberWithDots(mainData.min_investment)}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      setMainData({
                        ...mainData,
                        min_investment: result,
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </Box>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                justifyContent="space-between"
                gap={3}
              >
                <TextField
                  label="Fecha Inicial"
                  disabled={new Date(mainData.initial_date) < new Date()}
                  type="date"
                  value={dateToInput(mainData.initial_date)}
                  onChange={({ target }) => {
                    const myDate = new Date();

                    const currentDate = `${myDate.getFullYear()}-${String(
                      myDate.getMonth() + 1
                    ).padStart(2, "0")}-${String(myDate.getDate()).padStart(
                      2,
                      "0"
                    )}`;

                    let result = calcDates(currentDate, target.value);

                    if (result < 0) {
                      showSnack(
                        "La fecha inicial no puede ser antes de la fecha actual"
                      );
                      return;
                    }

                    if (mainData.final_date.length !== 0) {
                      let result = calcDates(
                        mainData.initial_date,
                        target.value
                      );
                      if (result > 2) {
                        showSnack(
                          "La fecha inicial no puede ser mayor a la fecha final",
                          "error",
                          4000
                        );
                        return;
                      }
                    }

                    setMainData({
                      ...mainData,
                      initial_date: target.value,
                    });
                  }}
                  fullWidth
                />
                <TextField
                  label="Fecha limite"
                  type="date"
                  value={dateToInput(mainData.final_date)}
                  onChange={({ target }) => {
                    const myDate = new Date();

                    const currentDate = `${myDate.getFullYear()}-${String(
                      myDate.getMonth() + 1
                    ).padStart(2, "0")}-${String(myDate.getDate()).padStart(
                      2,
                      "0"
                    )}`;

                    if (
                      currentDate === target.value ||
                      target.value === mainData.initial_date
                    ) {
                      showSnack(
                        "Error, las fecha inicial y final no pueden ser iguales."
                      );
                      return;
                    }

                    let result = calcDates(mainData.initial_date, target.value);

                    if (result < 1) {
                      showSnack(
                        "Error, la fecha final no puede ser menor a la fecha inicial",
                        "error",
                        5000
                      );
                      return;
                    }

                    setMainData({
                      ...mainData,
                      final_date: target.value,
                    });
                  }}
                  fullWidth
                />
              </Box>
            </Stack>
            <Stack mb={2}>
              <Stack flexDirection="row" alignItems="center" mb={2}>
                <Typography component="h3" variant="h6" mr={2}>
                  Imágenes del proyecto
                </Typography>
                <IconButton
                  onClick={() => fileGallery.current.click()}
                  size="small"
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    "&:hover": { backgroundColor: "primary.300" },
                  }}
                >
                  <AddIcon fontSize="small" />
                </IconButton>

                <input
                  onChange={handlerAddGalleryImage}
                  style={{ display: "none" }}
                  type="file"
                  accept=".jpg, .png, .jpeg, .webp"
                  ref={fileGallery}
                />
              </Stack>
              <GalleryProfile
                setGalleryImages={setGalleryPreview}
                data={galleryPreview}
                mainData={mainData}
                setDataProfile={setMainData}
              />
            </Stack>
            <Stack mb={2}>
              <Typography component="h3" variant="h6" mb={2}>
                Beneficio de inversores
              </Typography>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                gap={4}
                mb={2}
              >
                <TextField
                  label="Capital mínimo ofrecido"
                  value={formatNumberWithDots(
                    mainData.DetailProject.min_offered_capital
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          min_offered_capital: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Capital máximo ofrecido"
                  value={formatNumberWithDots(
                    mainData.DetailProject.max_offered_capital
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          max_offered_capital: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                gap={4}
                mb={2}
              >
                <TextField
                  label="Mínimo retorno de inversión"
                  value={formatNumberWithDots(
                    mainData.DetailProject.min_return_investment.replace(
                      "%",
                      ""
                    )
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          min_return_investment: result + "%",
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Máximo retorno de inversión"
                  value={formatNumberWithDots(
                    mainData.DetailProject.max_return_investment.replace(
                      "%",
                      ""
                    )
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          max_return_investment: result + "%",
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                display="flex"
                flexDirection={{ xs: "column", md: "row" }}
                gap={4}
                mb={2}
              >
                <TextField
                  label="Participaciones mínimas a dar"
                  value={formatNumberWithDots(
                    mainData.DetailProject.min_stake.replace("%", "")
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          min_stake: result + "%",
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Participaciones máximas a dar"
                  value={formatNumberWithDots(
                    mainData.DetailProject.max_stake.replace("%", "")
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          max_stake: result + "%",
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                flexDirection={{ xs: "column", md: "row" }}
                display="flex"
                gap={4}
              >
                <TextField
                  label="Garantía inmobiliaria"
                  value={formatNumberWithDots(
                    mainData.DetailProject.warranty_inmobiliaria
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          warranty_inmobiliaria: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Garantía económica"
                  value={formatNumberWithDots(
                    mainData.DetailProject.warranty_economica
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          warranty_economica: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
            </Stack>
            <Stack mb={4}>
              <Typography component="h3" variant="h6" mb={2}>
                Destino de inversión
              </Typography>

              <Box
                flexDirection={{ xs: "column", md: "row" }}
                display="flex"
                gap={4}
                mb={2}
              >
                <TextField
                  label="Minimo invertido marketing"
                  value={formatNumberWithDots(
                    mainData.DetailProject.min_marketing
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          min_marketing: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Máximo invertido marketing"
                  value={formatNumberWithDots(
                    mainData.DetailProject.max_marketing
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          max_marketing: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                flexDirection={{ xs: "column", md: "row" }}
                display="flex"
                gap={4}
                mb={2}
              >
                <TextField
                  label="Minimo invertido construcción"
                  value={formatNumberWithDots(
                    mainData.DetailProject.min_construction
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          min_construction: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Máximo invertido construcción"
                  value={formatNumberWithDots(
                    mainData.DetailProject.max_construction
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        DetailProject: {
                          ...mainData.DetailProject,
                          max_construction: result,
                        },
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                flexDirection={{ xs: "column", md: "row" }}
                display="flex"
                gap={4}
                mb={2}
              >
                <TextField
                  label="Gastos de construcción"
                  value={formatNumberWithDots(
                    mainData.ExpensesProjects[0].expenses_construction
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        ExpensesProjects: [
                          {
                            ...mainData.ExpensesProjects[0],
                            expenses_construction: result,
                          },
                        ],
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Gastos de marketing"
                  value={formatNumberWithDots(
                    mainData.ExpensesProjects[0].expenses_marketing
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        ExpensesProjects: [
                          {
                            ...mainData.ExpensesProjects[0],
                            expenses_marketing: result,
                          },
                        ],
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                flexDirection={{ xs: "column", md: "row" }}
                display="flex"
                gap={4}
                mb={2}
              >
                <TextField
                  label="Gastos de vehículos"
                  value={formatNumberWithDots(
                    mainData.ExpensesProjects[0].expenses_vehicles
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        ExpensesProjects: [
                          {
                            ...mainData.ExpensesProjects[0],
                            expenses_vehicles: result,
                          },
                        ],
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
                <TextField
                  label="Gastos de salarios"
                  value={formatNumberWithDots(
                    mainData.ExpensesProjects[0].expenses_wages
                  )}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        ExpensesProjects: [
                          {
                            ...mainData.ExpensesProjects[0],
                            expenses_wages: result,
                          },
                        ],
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
              <Box
                flexDirection={{ xs: "column", md: "row" }}
                display="flex"
                gap={4}
                mb={2}
              >
                <TextField
                  label="Invertido"
                  value={formatNumberWithDots(mainData.invested)}
                  onChange={({ target }) => {
                    let result = handleChange(target.value);
                    if (/^\d*$/.test(result)) {
                      result = result.slice(0, 10);
                      setMainData({
                        ...mainData,
                        invested: result,
                      });
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EuroIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="text"
                  fullWidth
                />
              </Box>
            </Stack>
            {mainData.verified === "approved" && (
              <Stack mb={8}>
                <Typography component="h3" variant="h6" mb={2}>
                  Seguimiento detallado
                </Typography>
                <Stack flexDirection={{ xs: "column", md: "row" }} gap={4}>
                  <Stack sx={{ width: "100%" }}>
                    <Typography
                      component="span"
                      my={2}
                      fontWeight={400}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      Gastos
                      <IconButton
                        size="small"
                        onClick={() => {
                          setModalNewBill(true);
                        }}
                        sx={{
                          backgroundColor: "primary.300",
                          color: "white",
                          "&:hover": { backgroundColor: "primary.main" },
                        }}
                      >
                        <Add fontSize="small" />
                      </IconButton>
                    </Typography>
                    <Paper sx={{ width: "100%", overflow: "hidden" }}>
                      <TableContainer
                        sx={{ maxHeight: 440, overflowX: "auto" }}
                      >
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell width="40%">
                                Nombre
                              </StyledTableCell>
                              <StyledTableCell width="30%" align="right">
                                Valor
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ whiteSpace: "nowrap" }}
                                width="30%"
                              >
                                Fecha de Creación
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                Acciones
                              </StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {stadisticsData.bills.length > 0 ? (
                              <>
                                {stadisticsData.bills.map((row) => (
                                  <TableRow hover key={row.id}>
                                    <TableCell width="40%">
                                      {row.name}
                                    </TableCell>
                                    <TableCell width="30%" align="right">
                                      {parseInt(row?.value).toLocaleString(
                                        "es-CO"
                                      )}
                                    </TableCell>
                                    <TableCell width="30%" align="right">
                                      {dateToInput(row?.createdAt)}
                                    </TableCell>
                                    <TableCell>
                                      <Stack direction="row">
                                        <IconButton
                                          aria-label="edit"
                                          onClick={() => {
                                            setBillToEdit(row);
                                            setOpenModalEditBill(true);
                                          }}
                                        >
                                          <EditIcon />
                                        </IconButton>
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => {
                                            setBillToDeleteId(row.id);
                                            setOpenModalDeleteBill(true);
                                          }}
                                        >
                                          <DeleteIcon sx={{ color: "red" }} />
                                        </IconButton>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </>
                            ) : (
                              <TableRow hover>
                                <TableCell
                                  colSpan={4}
                                  sx={{
                                    textAlign: "center",
                                    color: "GrayText",
                                  }}
                                >
                                  Sin gastos por el momento
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Stack>
                  <Stack sx={{ width: "100%" }}>
                    <Typography
                      component="span"
                      my={2}
                      fontWeight={400}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      Ingresos previstos
                      <IconButton
                        size="small"
                        sx={{
                          backgroundColor: "primary.300",
                          color: "white",
                          "&:hover": { backgroundColor: "primary.main" },
                        }}
                        onClick={() => setModalNewIncome(true)}
                      >
                        <Add fontSize="small" />
                      </IconButton>
                    </Typography>
                    <Paper sx={{ width: "100%", overflow: "hidden" }}>
                      <TableContainer
                        sx={{ maxHeight: 440, overflowX: "auto" }}
                      >
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell width="40%">
                                Nombre
                              </StyledTableCell>
                              <StyledTableCell width="30%" align="right">
                                Valor
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ whiteSpace: "nowrap" }}
                                width="30%"
                              >
                                Fecha de Creación
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                Acciones
                              </StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {stadisticsData.expected_income.length > 0 ? (
                              <>
                                {stadisticsData.expected_income.map((row) => (
                                  <TableRow hover key={row.id}>
                                    <TableCell width="40%">
                                      {row.name}
                                    </TableCell>
                                    <TableCell width="30%" align="right">
                                      {parseInt(row?.value).toLocaleString(
                                        "es-CO"
                                      )}
                                    </TableCell>
                                    <TableCell width="30%" align="right">
                                      {dateToInput(row?.createdAt)}
                                    </TableCell>
                                    <TableCell>
                                      <Stack direction="row">
                                        <IconButton
                                          aria-label="edit"
                                          onClick={() => {
                                            setIncomeToEdit(row);
                                            setOpenModalEditIncome(true);
                                          }}
                                        >
                                          <EditIcon />
                                        </IconButton>
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => {
                                            setIncomeToDeleteId(row.id);
                                            setOpenModalDeleteIncome(true);
                                          }}
                                        >
                                          <DeleteIcon sx={{ color: "red" }} />
                                        </IconButton>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </>
                            ) : (
                              <TableRow hover>
                                <TableCell
                                  colSpan={4}
                                  sx={{
                                    textAlign: "center",
                                    color: "GrayText",
                                  }}
                                >
                                  Sin ingresos previstos por el momento
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Stack>
                </Stack>
              </Stack>
            )}
            <LoadingButton
              loading={isLoading}
              disabled={isLoading}
              sx={{ backgroundColor: "primary.300" }}
              onClick={handlerUpdate}
            >
              ACTUALIZAR
            </LoadingButton>
          </Stack>
        ) : (
          ""
        )}
      </Stack>
      <Modal open={modalNewBill}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Añadir nuevo gasto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={dataNewBill.name}
              onChange={({ target }) => {
                setDataNewBill({ ...dataNewBill, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={formatNumberWithDots(dataNewBill.value)}
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setDataNewBill({ ...dataNewBill, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => {
                setModalNewBill(false);
                setDataNewBill({ name: "", value: "" });
              }}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleNewBill("bill");
              }}
            >
              Crear
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={openModalEditBill}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Actualizar gasto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={billToEdit?.name ? billToEdit?.name : null}
              onChange={({ target }) => {
                setBillToEdit({ ...billToEdit, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={
                billToEdit?.value
                  ? formatNumberWithDots(billToEdit.value)
                  : null
              }
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setBillToEdit({ ...billToEdit, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={loadingEditBill}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setOpenModalEditBill(false)}
            >
              Cancelar
            </Button>
            <Button
              disabled={loadingEditBill}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                setLoadingEditBill(true);
                loadApi(`bills/${billToEdit.id}`, true, "put", billToEdit)
                  .then((response) => {
                    let tempData = stadisticsData;
                    tempData = {
                      ...tempData,
                      bills: tempData.bills.map((bill) =>
                        bill.id === billToEdit.id ? billToEdit : bill
                      ),
                    };
                    setStadisticsData(tempData);
                    showSnack(response.data.message, "success");
                  })
                  .catch((e) => showSnack(e.message))
                  .finally(() => {
                    setLoadingEditBill(false);
                    setOpenModalEditBill(false);
                    setBillToEdit(undefined);
                  });
              }}
            >
              Actualizar
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={openModalEditIncome}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Actualizar ingreso previsto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={incomeToEdit?.name ? incomeToEdit?.name : null}
              onChange={({ target }) => {
                setIncomeToEdit({ ...incomeToEdit, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={
                incomeToEdit?.value
                  ? formatNumberWithDots(incomeToEdit.value)
                  : null
              }
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setIncomeToEdit({ ...incomeToEdit, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={loadingEditIncome}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => setOpenModalEditIncome(false)}
            >
              Cancelar
            </Button>
            <Button
              disabled={loadingEditIncome}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                setLoadingEditIncome(true);
                loadApi(
                  `expected/${incomeToEdit.id}`,
                  true,
                  "put",
                  incomeToEdit
                )
                  .then((response) => {
                    let tempData = stadisticsData;
                    tempData = {
                      ...tempData,
                      expected_income: tempData.expected_income.map((bill) =>
                        bill.id === incomeToEdit.id ? incomeToEdit : bill
                      ),
                    };
                    setStadisticsData(tempData);
                    showSnack(response.data.message, "success");
                  })
                  .catch((e) => showSnack(e.message))
                  .finally(() => {
                    setLoadingEditIncome(false);
                    setOpenModalEditIncome(false);
                    setIncomeToEdit(undefined);
                  });
              }}
            >
              Actualizar
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog
        open={openModalDeleteBill}
        onClose={() => {
          setOpenModalDeleteBill(false);
          setBillToDeleteId(undefined);
        }}
        aria-labelledby="alert-dialog-delete-bill"
      >
        <DialogTitle id="alert-dialog-delete-bill">
          ¿Estás seguro que deseas eliminar este gasto?
        </DialogTitle>
        <DialogActions>
          <Button
            disabled={loadingDeleteBill}
            onClick={() => {
              setOpenModalDeleteBill(false);
              setBillToDeleteId(undefined);
            }}
          >
            Cancelar
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={loadingDeleteBill}
            onClick={() => {
              setLoadingDeleteBill(true);
              loadApi(`bills/${billToDeleteId}`, true, "delete")
                .then((response) => {
                  let tempData = stadisticsData;
                  tempData = {
                    ...tempData,
                    bills: tempData.bills.filter(
                      (b) => b.id !== billToDeleteId
                    ),
                  };
                  setStadisticsData(tempData);
                  showSnack(response.data.message, "success");
                })
                .catch((e) => showSnack(e.message))
                .finally(() => {
                  setLoadingDeleteBill(false);
                  setOpenModalDeleteBill(false);
                  setBillToDeleteId(undefined);
                });
            }}
            autoFocus
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openModalDeleteIncome}
        onClose={() => {
          setOpenModalDeleteIncome(false);
          setIncomeToDeleteId(undefined);
        }}
        aria-labelledby="alert-dialog-delete-income"
      >
        <DialogTitle id="alert-dialog-delete-income">
          ¿Estás seguro que deseas eliminar este ingreso previsto?
        </DialogTitle>
        <DialogActions>
          <Button
            disabled={loadingDeleteIncome}
            onClick={() => {
              setOpenModalDeleteIncome(false);
              setIncomeToDeleteId(undefined);
            }}
          >
            Cancelar
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={loadingDeleteIncome}
            onClick={() => {
              setLoadingDeleteIncome(true);
              loadApi(`expected/${incomeToDeleteId}`, true, "delete")
                .then((response) => {
                  let tempData = stadisticsData;
                  tempData = {
                    ...tempData,
                    expected_income: tempData.expected_income.filter(
                      (b) => b.id !== incomeToDeleteId
                    ),
                  };
                  setStadisticsData(tempData);
                  showSnack(response.data.message, "success");
                })
                .catch((e) => showSnack(e.message))
                .finally(() => {
                  setLoadingDeleteIncome(false);
                  setOpenModalDeleteIncome(false);
                  setIncomeToDeleteId(undefined);
                });
            }}
            autoFocus
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={modalNewIncome}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 340,
            bgcolor: "white",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
          }}
        >
          <Typography component="h4" mb={1}>
            Añadir Ingreso Previsto
          </Typography>
          <Stack gap={2}>
            <TextField
              label="Nombre"
              value={dataNewBill.name}
              onChange={({ target }) => {
                setDataNewBill({ ...dataNewBill, name: target.value });
              }}
            />
            <TextField
              label="Valor"
              value={formatNumberWithDots(dataNewBill.value)}
              onChange={({ target }) => {
                let result = handleChange(target.value);
                if (/^\d*$/.test(result)) {
                  setDataNewBill({ ...dataNewBill, value: result });
                }
              }}
            />
          </Stack>
          <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
            <Button
              disabled={isLoadingModals ? true : false}
              variant="outlined"
              sx={{ boxSizing: "border-box", width: 130, px: 1 }}
              onClick={() => {
                setModalNewIncome(false);
                setDataNewBill({ name: "", value: "" });
              }}
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={isLoadingModals}
              variant="contained"
              sx={{
                boxSizing: "border-box",
                color: "white",
                width: 130,
                px: 1,
              }}
              onClick={() => {
                handleNewBill("income");
              }}
            >
              Crear
            </LoadingButton>
          </Box>
        </Box>
      </Modal>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default EditProject;
